import { useMemo } from "react";

import RefreshButton from "../../../../common/components/refresh_button";
import DynamicIcon from "../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../common/components/primary_button";
import { PatrimonioChecklistInfo } from "../../domain/models/patrimonio_checklist_info";

/**
 * PatrimonioInspecaoTopHeader
 */

type Props = {
  title: string;
  info: PatrimonioChecklistInfo | null;
  additionalHeader?: React.ReactNode;
  onReload: () => void;
  onNewItem?: () => void | null;
};

export const PatrimonioInspecaoTopHeader = ({
  title,
  info,
  additionalHeader,
  onReload,
  onNewItem,
}: Props) => {
  const headerObraInformation = useMemo(() => {
    return (
      info && (
        <div className="w-full flex flex-col">
          <div className="w-full mt-2 text-black dark:text-white">
            <span className="font-extrabold text-xl mr-2">Centro de Custo: </span>
            {info.nomeCentroCusto && (
              <>
                <span className="mx-1 font-normal text-base">{info.nomeCentroCusto}</span>
              </>
            )}
            {info.descricaoInspecao && !info.nomeCentroCusto && (
              <>
                <span className="mx-1 font-bold text-xl">{info.descricaoInspecao}</span>
              </>
            )}
            {!info.descricaoInspecao && info.nomeCentroCusto && (
              <>
                <span className="mx-1 font-normal text-base">{info.nomeCentroCusto}</span>
              </>
            )}
          </div>
          {additionalHeader}
        </div>
      )
    );
  }, [
    info,
    additionalHeader,
  ]);

  return (
    <>
      <div className="w-full flex flex-col justify-between items-center">
        <div className="w-full flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">{title}</h1>
            <RefreshButton onClick={onReload} />
          </div>
        </div>
        {info && headerObraInformation}
      </div>
      {onNewItem != null && onNewItem !== undefined ? (
        <div className="w-full justify-end items-center flex gap-2">
          <div className="w-[130px] ">
            <PrimaryButton startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />} onClick={onNewItem}>
              Novo item
            </PrimaryButton>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
